var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"disabled":_vm.disabled,"value":_vm.value,"placeholder":_vm.$t('k8s.text_30')},on:{"change":_vm.clusterChange}},_vm._l((_vm.clusterOps),function(item){return _c('a-select-option',{key:item.id,attrs:{"title":item.name,"value":item.id}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }